var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',_vm._b({staticClass:"time-slider time-position-select",attrs:{"max":_vm.safeMaxTime,"value":[0, _vm.safeMaxTime]},on:{"change":function($event){return _vm.$emit('change', $event)}}},'vue-slider',_vm.options,false))}
var staticRenderFns = []

export { render, staticRenderFns }